export enum QuickSearchDateType {
  REQUESTED_APPOINTMENT_EARLIEST = 'REQUESTED_APPOINTMENT_EARLIEST',
  REQUESTED_APPOINTMENT_LATEST = 'REQUESTED_APPOINTMENT_LATEST',
  SCHEDULED_APPOINTMENT_EARLIEST = 'SCHEDULED_APPOINTMENT_EARLIEST',
  SCHEDULED_APPOINTMENT_LATEST = 'SCHEDULED_APPOINTMENT_LATEST',
  EXPECTED_ARRIVAL = 'EXPECTED_ARRIVAL',
  ACTUAL_ARRIVAL = 'ACTUAL_ARRIVAL',
}
